import { ApplicationResource, applicationResource } from '@witkac/kartamiejska-resources';
import { Application } from '@witkac/kartamiejska-shared';
import { tryParseInt } from '@witkac/utils/tryParseInt';

import { LocalStorage } from '@/enums/storage.enum';
import { EntityModule } from './entity.module';

/**
 * Moduł wniosków
 *
 * @export
 * @class ApplicationModule
 * @extends {EntityModule<Application, ApplicationResource>}
 */
export class ApplicationModule extends EntityModule<Application, ApplicationResource> {
  constructor() {
    super(applicationResource);
    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: async (context: any, filters: any): Promise<void> => {
        const { list, count } = await this.resource.list({
          profileId: tryParseInt(localStorage.getItem(LocalStorage.PROFILE_ID)),
          withInactive: true,
          ...filters
        });
        context.commit('saveList', list);
        context.commit('saveCount', count);
      }
    };
  }
}

export default new ApplicationModule();
